import { GameStateHook } from '../utils/useGameState';

interface Props {
  onPlay: () => void;
  onLevelSelect: () => void;
  onDaily: () => void;
  onProfile: () => void;
  gameState: GameStateHook;
}

export function MainMenu({ onPlay, onLevelSelect, onDaily, onProfile, gameState }: Props) {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>SOKOBAN</h1>
        <p style={styles.subtitle}>Push. Solve. Compete.</p>
      </div>

      <div style={styles.statsRow}>
        <div style={styles.stat}>
          <span style={styles.statValue}>{gameState.levelsCompleted}</span>
          <span style={styles.statLabel}>Levels</span>
        </div>
        <div style={styles.stat}>
          <span style={styles.statValue}>{gameState.totalStars}</span>
          <span style={styles.statLabel}>Stars</span>
        </div>
        <div style={{
          ...styles.stat,
          ...(gameState.streak > 0 ? styles.streakActive : {}),
        }}>
          <span style={{
            ...styles.statValue,
            ...(gameState.streak > 0 ? styles.streakValue : {}),
          }}>
            {gameState.streak > 0 ? `${gameState.streak}` : '0'}
          </span>
          <span style={{
            ...styles.statLabel,
            ...(gameState.streak > 0 ? styles.streakLabel : {}),
          }}>
            {gameState.streak === 1 ? 'Day Streak' : 'Day Streak'}
          </span>
        </div>
      </div>

      <div style={styles.buttons}>
        <button style={{ ...styles.btn, ...styles.btnPrimary }} onClick={onPlay}>
          Continue Level {gameState.getNextUncompletedLevel()}
        </button>
        <button style={{ ...styles.btn, ...styles.btnSecondary }} onClick={onDaily}>
          Daily Puzzle
        </button>
        <button style={{ ...styles.btn, ...styles.btnSecondary }} onClick={onLevelSelect}>
          Level Select
        </button>
        <button style={{ ...styles.btn, ...styles.btnSmall }} onClick={onProfile}>
          Profile
        </button>
      </div>
    </div>
  );
}

const styles: Record<string, any> = {
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    gap: '24px',
  },
  header: {
    textAlign: 'center',
  },
  title: {
    fontSize: '48px',
    fontWeight: '900',
    letterSpacing: '8px',
    color: '#4ecdc4',
    textShadow: '0 0 20px rgba(78, 205, 196, 0.3)',
    margin: 0,
  },
  subtitle: {
    fontSize: '14px',
    color: '#888',
    letterSpacing: '4px',
    marginTop: '8px',
  },
  statsRow: {
    display: 'flex',
    gap: '32px',
    justifyContent: 'center',
  },
  stat: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
  },
  statValue: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#fff',
  },
  statLabel: {
    fontSize: '11px',
    color: '#888',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  streakActive: {
    background: 'rgba(255, 160, 50, 0.12)',
    borderRadius: '12px',
    padding: '8px 16px',
  },
  streakValue: {
    color: '#ffa032',
  },
  streakLabel: {
    color: '#ffa032',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
    maxWidth: '320px',
  },
  btn: {
    border: 'none',
    borderRadius: '12px',
    padding: '16px 24px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'transform 0.1s, opacity 0.1s',
    fontFamily: 'inherit',
  },
  btnPrimary: {
    background: 'linear-gradient(135deg, #4ecdc4, #44b3aa)',
    color: '#1a1a2e',
    fontSize: '18px',
  },
  btnSecondary: {
    background: 'rgba(255,255,255,0.1)',
    color: '#eee',
    border: '1px solid rgba(255,255,255,0.15)',
  },
  btnSmall: {
    background: 'rgba(255,255,255,0.06)',
    color: '#aaa',
    fontSize: '14px',
    padding: '12px 16px',
  },
};
